import React from 'react';
import {
    Button,
    Col,
    Row,
    Typography,
} from 'antd';


const { Text } = Typography;

const BookingTimeColumn = ({ label, onClick, times = [] }) => {
    if (!times.length) return null;

    return (
        <Col span={8}>
            <Row>
                <Col span={24}>
                    <Text type="secondary">{ label }:</Text>
                    <br />
                </Col>
                {
                    times.map(time =>
                        <Col span={24} key={time}>
                            <Button
                                htmlType="submit"
                                key={time}
                                style={{ minWidth: 100 }}
                                type="primary"
                                onClick={onClick(time)}
                            >
                                { time }
                            </Button>
                        </Col>
                    )
                }
            </Row>
        </Col>
    );
};

export default BookingTimeColumn;
